import React, {useContext, useEffect, useState} from 'react';
import {Text, Flex, Box, Spacer, Tooltip} from '@chakra-ui/react';
import ProductLogo from './productLogo';
import ProductInsightTags from './productInsightTags';
import { ProductContext } from '../lib/productContext';
import { Link } from 'react-router-dom';
import { ProfileContext } from '../../profile/lib/profileContext';
import ProfileThumbnail from '../../profile/component/profileThumbnail';
import { AuthContext } from '../../auth/lib/authContext';
import useTranslation from '../../lib/i18n/useTranslation';
export default function ProductListItem() {
  const { t } = useTranslation();
  const { product } = useContext(ProductContext);
  const {profile} = useContext(ProfileContext);
  const authContext = useContext(AuthContext);
  return (
    <Link to={`/products/${product.id}`} >
      <Flex
        alignItems="center"
        px={3}
        py={3}
        backgroundColor="white"
        _hover={{
          background: "background.grey",
        }}
      >
        <Flex
        alignItems={'center'}
        width={"100%"}
        maxWidth={"350px"}
        >
          <ProductLogo
            size={40}
            productId={product.id}
            hasLogo={product.has_logo}
            productName={product.name}
          />
          <Box ml={2} width={"100%"} >
            <Text
              w={"100%"}
              fontSize={16}
              noOfLines={"1"}
            >{product.name}</Text>
          </Box>
        </Flex>
        <Tooltip label={t('common.owner')}>
          <Flex
            alignItems={"center"}
            gap={1}
            width={"150px"}
            >
            <ProfileThumbnail size={25}/>
            {profile.id === authContext.profile.id && 
              <Text width={"100%"} fontSize={"12px"} noOfLines={1}>{t('common.me')}</Text>
            }
            {profile.id !== authContext.profile.id && 
              <Text width={"100%"} fontSize={"12px"} noOfLines={1}>{profile.pseudo}</Text>
            }
          </Flex>
        </Tooltip>
        <Flex
          flex={1}
          justifyContent={"flex-end"}
          >
          <ProductInsightTags
            productId={product.id}
            insightMetadata={product.insight_metadata}
        />
        </Flex>
      </Flex>
    </Link>
  );
}
